import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200 flex-shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center py-16"
};
const _hoisted_5 = {
  key: 1,
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_6 = {
  key: 0,
  class: "mb-4 rounded-xl bg-green-50 border border-green-100 p-4"
};
const _hoisted_7 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4"
};
const _hoisted_8 = {
  class: "text-sm font-mono text-slate-900 break-all"
};
const _hoisted_9 = {
  class: "text-sm text-slate-900"
};
const _hoisted_10 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_11 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_12 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_13 = {
  key: 0,
  class: "bg-amber-50 rounded-xl p-4"
};
const _hoisted_14 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_15 = {
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl flex-shrink-0"
};
const _hoisted_16 = ["disabled"];
const _hoisted_17 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { createFranchiseePlatformLakalaReceiver, getFranchiseePlatformLakalaReceiver, updateFranchiseePlatformLakalaReceiver } from '@/api/commission';
export default {
  __name: 'PlatformLakalaReceiverFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    franchiseeId: {
      type: [Number, String],
      default: null
    },
    franchiseeInfo: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formRef = ref(null);
    const loading = ref(false);
    const submitting = ref(false);
    const currentAccount = ref(null);
    const getInitialFormData = () => ({
      receiverName: '',
      contactMobile: '',
      licenseNo: '',
      licenseName: '',
      legalPersonName: '',
      legalPersonCertificateType: '',
      legalPersonCertificateNo: '',
      acctNo: '',
      acctName: '',
      acctTypeCode: '',
      acctCertificateType: '',
      acctCertificateNo: '',
      acctOpenBankCode: '',
      acctOpenBankName: '',
      acctClearBankCode: '',
      settleType: ''
    });
    const formData = reactive(getInitialFormData());
    const isEdit = computed(() => !!currentAccount.value?.receiverNo);
    const requiresManualBankInfo = computed(() => formData.acctTypeCode === '57');
    const franchiseeTitle = computed(() => {
      const name = props.franchiseeInfo?.name;
      return name ? `${name}的平台分账接收方` : '加盟商平台分账接收方';
    });
    const receiverStatusText = computed(() => {
      const status = currentAccount.value?.receiverStatus;
      if (status === 'VALID') return '可用';
      if (status === 'INVALID') return '不可用';
      if (status === 'PENDING') return '处理中';
      return '未同步';
    });
    const receiverStatusClass = computed(() => {
      const status = currentAccount.value?.receiverStatus;
      if (status === 'VALID') return 'status-badge is-success';
      if (status === 'INVALID') return 'status-badge is-rose';
      return 'status-badge is-warning';
    });
    const rules = computed(() => {
      const baseRules = {
        receiverName: [{
          required: true,
          message: '请输入接收方名称',
          trigger: 'blur'
        }],
        contactMobile: [{
          required: true,
          message: '请输入联系手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        acctTypeCode: [{
          required: true,
          message: '请选择账户类型',
          trigger: 'change'
        }],
        acctName: [{
          required: true,
          message: '请输入收款账户名',
          trigger: 'blur'
        }],
        acctNo: [{
          required: true,
          message: '请输入收款账号',
          trigger: 'blur'
        }],
        acctCertificateType: [{
          required: true,
          message: '请选择账户证件类型',
          trigger: 'change'
        }],
        acctCertificateNo: [{
          required: true,
          message: '请输入账户证件号',
          trigger: 'blur'
        }]
      };
      if (requiresManualBankInfo.value) {
        baseRules.acctOpenBankCode = [{
          required: true,
          message: '请输入开户行号',
          trigger: 'blur'
        }];
        baseRules.acctOpenBankName = [{
          required: true,
          message: '请输入开户行名称',
          trigger: 'blur'
        }];
        baseRules.acctClearBankCode = [{
          required: true,
          message: '请输入清算行行号',
          trigger: 'blur'
        }];
      }
      if (formData.acctTypeCode === '57') {
        baseRules.licenseNo = [{
          required: true,
          message: '请输入营业执照号',
          trigger: 'blur'
        }];
        baseRules.licenseName = [{
          required: true,
          message: '请输入营业执照名称',
          trigger: 'blur'
        }];
        baseRules.legalPersonName = [{
          required: true,
          message: '请输入法人姓名',
          trigger: 'blur'
        }];
        baseRules.legalPersonCertificateType = [{
          required: true,
          message: '请选择法人证件类型',
          trigger: 'change'
        }];
        baseRules.legalPersonCertificateNo = [{
          required: true,
          message: '请输入法人证件号',
          trigger: 'blur'
        }];
      }
      return baseRules;
    });
    const resetForm = () => {
      const initial = getInitialFormData();
      Object.keys(initial).forEach(key => {
        const value = currentAccount.value?.[key] ?? initial[key];
        formData[key] = key === 'acctTypeCode' && value !== null && value !== undefined ? String(value) : value;
      });
    };
    const loadAccount = async () => {
      if (!props.franchiseeId) {
        currentAccount.value = null;
        resetForm();
        return;
      }
      loading.value = true;
      try {
        currentAccount.value = await getFranchiseePlatformLakalaReceiver(props.franchiseeId);
        resetForm();
      } catch (error) {
        currentAccount.value = null;
        resetForm();
        console.error('查询平台分账账户失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const compactPayload = payload => {
      return Object.entries(payload).reduce((result, [key, value]) => {
        if (value === '' || value === null || value === undefined) return result;
        result[key] = value;
        return result;
      }, {});
    };
    const buildSubmitData = () => {
      const payload = compactPayload({
        ...formData
      });
      const derivedPayloadFields = ['tenantId', 'lakalaCredentialMode', 'lakalaCredentialId', 'lakalaAppId', 'lakalaSerialNo', 'orgCode', 'merInnerNo'];
      derivedPayloadFields.forEach(key => {
        delete payload[key];
      });
      if (!requiresManualBankInfo.value) {
        delete payload.acctOpenBankCode;
        delete payload.acctOpenBankName;
        delete payload.acctClearBankCode;
      }
      if (isEdit.value && currentAccount.value?.receiverStatus) {
        payload.receiverStatus = currentAccount.value.receiverStatus;
      }
      return payload;
    };
    const handleSubmit = async () => {
      try {
        if (!props.franchiseeId) {
          ElMessage.warning('缺少加盟商ID');
          return;
        }
        await formRef.value.validate();
        submitting.value = true;
        if (isEdit.value) {
          await updateFranchiseePlatformLakalaReceiver(props.franchiseeId, buildSubmitData());
          ElMessage.success('平台分账账户变更已提交');
        } else {
          await createFranchiseePlatformLakalaReceiver(props.franchiseeId, buildSubmitData());
          ElMessage.success('平台分账账户创建申请已提交');
        }
        emit('success');
        handleClose();
      } catch (error) {
        console.error('保存平台分账账户失败:', error);
        if (error !== false) {
          ElMessage.error(error.message || '保存失败');
        }
      } finally {
        submitting.value = false;
      }
    };
    const handleClose = () => {
      emit('update:visible', false);
    };
    watch(() => [props.visible, props.franchiseeId], ([visible]) => {
      if (visible) {
        loadAccount();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "3xl",
        "z-index": 60,
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(isEdit.value ? '变更平台分账账户' : '创建平台分账账户'), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(franchiseeTitle.value), 1)]), _createElementVNode("button", {
          onClick: handleClose,
          class: "p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[17] || (_cache[17] = [_createElementVNode("div", {
          class: "w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"
        }, null, -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [currentAccount.value?.receiverNo ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "text-xs text-green-700 mb-1"
        }, "接收方编号", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(currentAccount.value.receiverNo), 1)]), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-xs text-green-700 mb-1"
        }, "接收方状态", -1)), _createElementVNode("span", {
          class: _normalizeClass(["status-badge", receiverStatusClass.value])
        }, _toDisplayString(receiverStatusText.value), 3)]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "text-xs text-green-700 mb-1"
        }, "更新时间", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(currentAccount.value.updateTime || '-'), 1)])])])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: rules.value,
          "label-width": "130px",
          class: "space-y-6"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[21] || (_cache[21] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 基本信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "接收方名称",
            prop: "receiverName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.receiverName = $event),
              type: "text",
              placeholder: "请输入平台分账接收方名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.receiverName, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系手机",
            prop: "contactMobile"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.contactMobile = $event),
              type: "text",
              placeholder: "请输入联系电话",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.contactMobile, void 0, {
              trim: true
            }]])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_11, [_cache[22] || (_cache[22] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          })]), _createTextVNode(" 收款账户信息 ")], -1)), _createVNode(_component_el_form_item, {
            label: "账户类型",
            prop: "acctTypeCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.acctTypeCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.acctTypeCode = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "请选择账户类型",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "对公账户",
                value: "57"
              }), _createVNode(_component_el_option, {
                label: "对私账户",
                value: "58"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "收款账户名",
            prop: "acctName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.acctName = $event),
              type: "text",
              placeholder: "请输入收款账户名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctName, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "收款账号",
            prop: "acctNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.acctNo = $event),
              type: "text",
              placeholder: "请输入收款账户卡号",
              class: "form-input w-full font-mono"
            }, null, 512), [[_vModelText, formData.acctNo, void 0, {
              trim: true
            }]])]),
            _: 1
          }), requiresManualBankInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_form_item, {
            label: "开户行号",
            prop: "acctOpenBankCode"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.acctOpenBankCode = $event),
              type: "text",
              placeholder: "请输入开户行号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctOpenBankCode, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "清算行行号",
            prop: "acctClearBankCode"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.acctClearBankCode = $event),
              type: "text",
              placeholder: "请输入清算行行号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctClearBankCode, void 0, {
              trim: true
            }]])]),
            _: 1
          })])) : _createCommentVNode("", true), requiresManualBankInfo.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "开户行名称",
            prop: "acctOpenBankName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.acctOpenBankName = $event),
              type: "text",
              placeholder: "请输入开户行名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.acctOpenBankName, void 0, {
              trim: true
            }]])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "账户证件类型",
            prop: "acctCertificateType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.acctCertificateType,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.acctCertificateType = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "请选择证件类型",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "身份证",
                value: "17"
              }), _createVNode(_component_el_option, {
                label: "护照",
                value: "18"
              }), _createVNode(_component_el_option, {
                label: "港澳居民来往内地通行证",
                value: "19"
              }), _createVNode(_component_el_option, {
                label: "台湾居民来往内地通行证",
                value: "20"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "账户证件号",
            prop: "acctCertificateNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.acctCertificateNo = $event),
              type: "text",
              placeholder: "请输入账户证件号",
              class: "form-input w-full font-mono"
            }, null, 512), [[_vModelText, formData.acctCertificateNo, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "提现类型",
            prop: "settleType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.settleType,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.settleType = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "请选择提现类型",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "主动提款",
                value: "01"
              }), _createVNode(_component_el_option, {
                label: "交易自动结算",
                value: "03"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]), formData.acctTypeCode === '57' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[23] || (_cache[23] = _createElementVNode("h4", {
            class: "text-sm font-medium text-amber-800 mb-4 flex items-center gap-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414A1 1 0 0119 9.414V19a2 2 0 01-2 2z"
          })]), _createTextVNode(" 对公资料 ")], -1)), _createVNode(_component_el_form_item, {
            label: "营业执照号",
            prop: "licenseNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.licenseNo = $event),
              type: "text",
              placeholder: "请输入营业执照号",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.licenseNo, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "营业执照名",
            prop: "licenseName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.licenseName = $event),
              type: "text",
              placeholder: "请输入营业执照名称",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.licenseName, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人姓名",
            prop: "legalPersonName"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.legalPersonName = $event),
              type: "text",
              placeholder: "请输入法人姓名",
              class: "form-input w-full"
            }, null, 512), [[_vModelText, formData.legalPersonName, void 0, {
              trim: true
            }]])]),
            _: 1
          }), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_form_item, {
            label: "法人证件类型",
            prop: "legalPersonCertificateType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.legalPersonCertificateType,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formData.legalPersonCertificateType = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "请选择证件类型",
                value: ""
              }), _createVNode(_component_el_option, {
                label: "身份证",
                value: "17"
              }), _createVNode(_component_el_option, {
                label: "护照",
                value: "18"
              }), _createVNode(_component_el_option, {
                label: "港澳居民来往内地通行证",
                value: "19"
              }), _createVNode(_component_el_option, {
                label: "台湾居民来往内地通行证",
                value: "20"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "法人证件号",
            prop: "legalPersonCertificateNo"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formData.legalPersonCertificateNo = $event),
              type: "text",
              placeholder: "请输入法人证件号",
              class: "form-input w-full font-mono"
            }, null, 512), [[_vModelText, formData.legalPersonCertificateNo, void 0, {
              trim: true
            }]])]),
            _: 1
          })])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])])), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
          onClick: handleClose,
          class: "btn-secondary",
          disabled: submitting.value
        }, "取消", 8, _hoisted_16), _createElementVNode("button", {
          onClick: handleSubmit,
          class: "btn-primary",
          disabled: submitting.value
        }, _toDisplayString(submitting.value ? '提交中...' : isEdit.value ? '提交变更' : '创建接收方'), 9, _hoisted_17)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};